import { GithubTokens } from '../models';
import { GithubAuthDataService } from './github-auth-data.service';
import { Injectable } from '@angular/core';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class GithubTokensService {
  constructor(
    private githubAuthDataService: GithubAuthDataService,
    private luigiCoreService: LuigiCoreService,
  ) {}

  async reloadGitHubTokensIntoLuigiGlobalContext() {
    const tokens = this.getGithubTokens();
    this.luigiCoreService.setInGlobalContext(tokens, true);
  }

  getGithubTokens(): GithubTokens {
    const githubToolsToken =
      this.githubAuthDataService.getGithubAuthDataForDomain(
        'github.tools.sap',
      )?.access_token;
    const githubWdfToken =
      this.githubAuthDataService.getGithubAuthDataForDomain(
        'github.wdf.sap.corp',
      )?.access_token;
    const tokens = {
      githubToolsToken,
      githubWdfToken,
    };
    return tokens;
  }
}
